export default __webpack_public_path__ + "static/media/ethereum-classic.f7caf087.png";